import axios from 'axios';
import config from '../../config-api.json';
import {
  DeletePageClickStaticsResponse,
  GetPageMouseStaticsParamType,
  GetPageMouseStaticsResponseType,
  GetPageElementDataParamType,
  GetPageElementDataResponseType,
  GetEffectiveClickCountParamType,
  GetEffectiveClickCountResponseType,
  GetPageAttentionScreensCountParamType,
  GetPageAttentionScreensCountResponseType,
  GetPageDurationParamType,
  GetPageDurationResponseType,
  GetPageViewCountParamType,
  GetPageViewCountResponseType,
} from './type';

const env = process.env.NODE_ENV;
let { apiInfo } = config;

if (env === 'development') {
  apiInfo = config.apiInfo_dev;
}

export async function apiGetPageMouseStatics(
  info: GetPageMouseStaticsParamType
) {
  const response = await axios.get<GetPageMouseStaticsResponseType>(
    `${apiInfo.api_url}/page_click_statics/`,
    {
      params: {
        start_date: info.start_date,
        end_date: info.end_date,
        page_id: info.page_id,
        event_status: info.event_status,
      },
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function apiDeletePageClickStatics() {
  const response = await axios.delete<DeletePageClickStaticsResponse>(
    `${apiInfo.api_url}/save_click_events/`,
    {
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}

// element data
export async function apiGetPageElementData(info: GetPageElementDataParamType) {
  const response = await axios.get<GetPageElementDataResponseType>(
    `${apiInfo.api_url}/page_elements/`,
    {
      params: {
        start_date: info.start_date,
        end_date: info.end_date,
        page_id: info.page_id,
        event_status: info.event_status,
      },
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function apiGetEffectiveClickCount(
  info: GetEffectiveClickCountParamType
) {
  const response = await axios.get<GetEffectiveClickCountResponseType>(
    `${apiInfo.api_url}/page_elements_click/`,
    {
      params: {
        start_date: info.start_date,
        end_date: info.end_date,
        page_id: info.page_id,
      },
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function apiGetPageViewCount(info: GetPageViewCountParamType) {
  const response = await axios.get<GetPageViewCountResponseType>(
    `${apiInfo.api_url}/page_view_cnt/`,
    {
      params: {
        start_date: info.start_date,
        end_date: info.end_date,
        page_id: info.page_id,
      },
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function apiGetPageAttentionScreensCount(
  info: GetPageAttentionScreensCountParamType
) {
  const response = await axios.get<GetPageAttentionScreensCountResponseType>(
    `${apiInfo.api_url}/page_attention_statistics/`,
    {
      params: {
        start_date: info.start_date,
        end_date: info.end_date,
        page_id: info.page_id,
      },
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}

export async function apiGetPageDuration(info: GetPageDurationParamType) {
  const response = await axios.get<GetPageDurationResponseType>(
    `${apiInfo.api_url}/page_duration_statistics/`,
    {
      params: {
        start_date: info.start_date,
        end_date: info.end_date,
        page_id: info.page_id,
      },
      headers: {
        Tenant: localStorage.getItem('voda_tenant'),
      },
      withCredentials: true,
    }
  );
  return response.data;
}
